import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {GridComponent} from "@app/modules/shared/components/grid/grid.component";

@Component({
  selector: 'kl-lem-info-list',
  templateUrl: './lem-info-list.component.html',
  styleUrls: ['./lem-info-list.component.scss']
})
export class LemInfoListComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() tabId: string;
  @Input() modalId: string;
  @Input() dblSelect = true;
  @ViewChild("gridComponent", { static: true }) gridComponent:GridComponent;
  filterSelectItems = [
    {
      name: "company_title",
      description: "customer_title",
    },
    {
      name: "tax_nr",
      description: "tax_nr",
    },
    {
      name: "logo_product_key",
      description: "logo_product_key",
    },
  ];
  filterObject: any;
  private originalGridFilter: (filter: any) => void;
  private originalDeleteRecord: (payload: any) => void;
  constructor() { }

  ngOnInit(): void {
    this.setupGridFilterOverride();
  }
  ngAfterViewInit(): void {
    this.setupGridFilterOverride();
    this.setupDeleteRecordOverride();
  }

  private setupGridFilterOverride(): void {
    if (!this.gridComponent || this.originalGridFilter) {
      return;
    }

    this.originalGridFilter = this.gridComponent.filter.bind(this.gridComponent);
    this.gridComponent.filter = (request: any) => {
      this.originalGridFilter({
        filter: request && request.filter ? request.filter : {},
      });
    };
  }

  private setupDeleteRecordOverride(): void {
    if (!this.gridComponent || this.originalDeleteRecord) {
      return;
    }

    this.originalDeleteRecord = this.gridComponent.deleteRecord.bind(this.gridComponent);
    this.gridComponent.deleteRecord = (payload: any) => {
      const service = this.gridComponent.service;
      const hasIds = payload?.ids !== undefined && payload?.ids !== null;
      const hasId = payload?.id !== undefined && payload?.id !== null;

      if (!hasIds && !hasId) {
        return;
      }

      if (hasIds) {
        const serviceUrl = `${service.service}/${service.customEndpoint}`;
        const requestId = payload.logo_product_key;

        this.gridComponent['klLoadingService'].show('loading');
        this.gridComponent['apiService'].getDataById(serviceUrl, requestId).subscribe(
          (responseGetByID) => {
            if (responseGetByID === undefined) {
              this.gridComponent.handleError('error_data');
            } else {
              this.gridComponent['klLoadingService'].hide();
              this.gridComponent['alertService'].alertDelete(
                {
                  title: 'Uyarı',
                  text: 'Kayıt Silinecektir',
                  customClass: 'kl-alert',
                  showCloseButton: false,
                  confirm: this.gridComponent.deleteOptions.deleteWithConfirm,
                  inputPlaceholder: this.gridComponent.deleteOptions.inputPlaceholder,
                },
                (response) => {
                  this.gridComponent['klLoadingService'].show('deleting');
                  this.gridComponent['alertShow'] = false;
                  this.gridComponent['apiService']
                    .deleteData(
                      response === 1 && this.gridComponent.deleteOptions.deleteWithConfirm
                        ? this.gridComponent.deleteOptions.delete_related
                        : service.service,
                      payload.id
                    )
                    .finally(() => {
                      this.gridComponent['klLoadingService'].hide();
                      this.gridComponent.changeDetector.markForCheck();
                    })
                    .subscribe(
                      () => {
                        this.gridComponent['toastService'].toastSuccess();
                        this.gridComponent.filter(this.gridComponent['_filter']);
                      },
                      (err) => this.gridComponent.handleError(err)
                    );
                }
              );
            }
          },
          (error) => this.gridComponent.handleError(error)
        );
      } else {
        this.originalDeleteRecord(payload);
      }
    };
  }

  onSelect(row) {
    console.log(row);
    console.log(row.branch_count);
  }
  ngOnDestroy(): void {
    if (this.originalGridFilter) {
      this.gridComponent.filter = this.originalGridFilter;
    }
    if (this.originalDeleteRecord) {
      this.gridComponent.deleteRecord = this.originalDeleteRecord;
    }
  }
}

